import { useIstSchreibtisch } from '@/hooks/useLayout';

// A14.5 — Der QR zur Übergabe (#72, E37).
//
// DER FALL, DEN ER LÖST
//   Jemand steht am Bürorechner und hat die Bestellung offen. Das Buch
//   liegt im Laden, das Tablet ist dort. Bisher hieß das: Nummer
//   abschreiben oder merken, am Tablet suchen. Der Code hier nimmt die
//   Nummer mit — Tablet-Kamera drauf, dieselbe Bestellung ist offen.
//
// DASSELBE ZIEL WIE AUF DEM ZETTEL
//   `/s/<nummer>`, dieselbe Kurz-Weiterleitung, dasselbe Bild aus
//   `/api/qr.php`. Kein zweiter Endpunkt und keine neue Abhängigkeit:
//   was der Zettel kann, kann der Bildschirm auch.
//
// WARUM 104 PIXEL UND NICHT KLEINER
//   Der Code misst 41 Module über die Kante (33 plus je vier Ruhezone).
//   Bei 104 CSS-Pixeln ist ein Modul rund 2,5 px groß, auf einem
//   üblichen Schirm also etwa 0,67 mm. Die Faustregel für Handykameras
//   verlangt 0,5 mm, und der übliche Lese-Abstand liegt beim Zehnfachen
//   der Kantenlänge — bei 27 mm Kante also rund 27 cm. Genau die
//   Haltung, in der jemand ein Tablet vor den Monitor hält.
//
//   Kleiner wäre nicht „etwas schlechter", sondern wertlos: ein Code,
//   den die Kamera nicht fasst, ist schlimmer als keiner, weil man es
//   erst nach dem Versuch merkt.
//
// WO ER NICHT ERSCHEINT
//   Nicht im Druck — der Zettel hat seinen eigenen QR oben links, und
//   zwei Codes auf einem Blatt sind eine Frage zu viel.
//   Nicht auf Telefon und Tablet — dort ist man schon auf dem Gerät, auf
//   das der Code führen würde.
//   Nicht in Dashboard-Zeilen — dreißig Codes untereinander sind kein
//   Angebot, sondern Rauschen.

const KANTE = 104;

export function UebergabeQr({ bestellnr }: { bestellnr: string }) {
  const amSchreibtisch = useIstSchreibtisch();
  if (!amSchreibtisch) return null;

  // Absolute URL, damit der Code auch dann trägt, wenn das Tablet ihn
  // ohne unsere Seite im Rücken öffnet.
  const ziel = `${window.location.origin}/s/${encodeURIComponent(bestellnr)}`;
  const bild = `/api/qr.php?d=${encodeURIComponent(ziel)}`;

  return (
    <figure className="flex shrink-0 flex-col items-center gap-1 print:hidden">
      <img
        src={bild}
        alt={`QR-Code zu ${bestellnr}`}
        width={KANTE}
        height={KANTE}
        className="rounded-sm border border-line bg-cream p-1"
        style={{ width: KANTE, height: KANTE }}
      />
      {/* Ein Bildzeichen ohne Wort ist nicht benennbar. Der Satz sagt
          beides: was zu tun ist und was danach passiert.
          A16.3: hiess „Scannen: am Tablet öffnen" und schloss damit das
          Telefon aus, obwohl es genauso geht. Statt das zweite Gerät
          aufzuzählen, nennt der Satz jetzt den Zweck — die Bestellung
          mitnehmen, dorthin, wo das Buch liegt. Nennt kein Gerät und ist
          dabei kürzer als vorher. */}
      <figcaption className="text-xs text-ink-faint">Scannen und mitnehmen</figcaption>
    </figure>
  );
}
